import { FormField } from "./Types";
import { validatePastDate } from "Validator/Validator";

// Array of field configurations
export const formFields: FormField[] = [
    {
        label: "Client Name",
        name: "clientName",
        type: "text",
        required: "Client Name is required",
    },
    {
        label: "Email ID",
        name: "emailId",
        type: "email",
        required: "Email is required",
    },
    {
        label: "Password",
        name: "password",
        type: "password",
        required: "Password is required",
    },
    {
        label: "Mobile Number",
        name: "mobileNumber",
        type: "number",
        required: "Mobile Number is required",
    },
];

export const breadcrumbItems = [{ label: "Clients", link: "/auth/clients" }];
